import LRUMap from 'lru-cache'

let lru = new LRUMap(20)

export default function duration(n) {
  n = Number.parseInt(n, 10)
  if (isNaN(n)) {
    return ''
  }
  if (lru.get(n)) {
    return lru.get(n)
  }

  let k = n
  let intervals = [1, 60, 60, 24, 365]
  let words = ['second', 'minute', 'hour', 'day', 'year']
  let index = 0

  while (index < words.length) {
    k = k / intervals[index]
    if (k < intervals[index + 1]) {
      break
    }
    index++
  }

  k = Math.ceil(k)

  let word = words[index]
  let plural = k === 1 ? '' : 's'
  let result = `${k} ${word}${plural}`
  lru.set(n, result)

  return result
}
